<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
    [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Reassign Property
                </h4>
                <button type="button" class="close pull-right" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="medium-padding remove-margin">

                    <div class="row">
                        <div class="col-md-12">
                            You are reassigning the property <span style="font-weight: bold;">{{propertyName}}</span>
                            from the current portfolio <span style="font-weight: bold;">{{fromWorkspaceName}}</span>.
                        </div>
                    </div>

                    <div class="row margin-top-20">
                        <div class="col-md-12">
                            To select a new portfolio, please use the search below.
                        </div>
                    </div>

                    <div class="row margin-top-20">
                        <div class="col-md-12">
                            <dx-autocomplete 
                                #dxPortfolioSearch
                                placeholder="Search portfolios..." 
                                [dataSource]="filteredWorkspaces"
                                valueExpr="name" 
                                [searchExpr]="['name']" 
                                [minSearchLength]="2" 
                                showClearButton="true"
                                (onSelectionChanged)="onWorkspaceSelected($event)">
                            </dx-autocomplete>
                        </div>
                    </div>
                    <div class="row margin-top-20">
                        <div class="col-md-12">
                            <input name="includeUsers" id="includeUsers" type="checkbox" [checked]="includeUsers" (change)="toggleIncludeUsers()" />
                            <label for="includeUsers">Include Users</label>
                        </div>
                    </div>
                </div>
            </div>
            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-success" (click)="reassignProperty()"
                    [disabled]="!toWorkspaceId">Reassign Property</button>
            </footer>
        </div>
    </div>
</div>